<div #eRef class='TableTagsFilter'>
  <div (click)='toggleAvailableTags()' class='TableTagsFilter-input'>
    <p *ngIf='selectedTags.length; else placeholder'>{{ renderTags() }}</p>
    <ng-template #placeholder>
      <span class='text-muted'>Enter tags</span>
    </ng-template>
    <!--        show X icon if input value is not empty-->
    <span
      (click)='onClearInput()'
      *ngIf='selectedTags && selectedTags.length'
      class='TableTagsFilter-input-clear'
    >X</span
    >
    <fa-icon [icon]='icon' [size]="'1x'"
             class='TableTagsFilter-input-icon text-muted'></fa-icon>
  </div>
  <div *ngIf='showTagsList' class='TableTagsFilter-input-tagslist'>
    <div
      (click)='toggleTagSelection(tag)'
      *ngFor='let tag of tags'
      [class.active]='isTagSelected(tag)'
      class='TableTagsFilter-input-tagslist-tag'>
      <span>{{ tag.label }}</span>
    </div>
  </div>
  <div class='TableTagsFilter-button d-inline-block'>
    <button (click)='onSearch()'>{{ buttonLabel }}</button>
  </div>
</div>
